import type { SxStyle } from '@aibees/shared/theme';

const GRADIENT =
  'linear-gradient(135deg, #cfdbfc 0%, #f1f4ff 45%, #ffffff 100%)';

export const outerBox: SxStyle = {
  border: '1px solid',
  borderColor: 'primary.main',
  borderRadius: 1,
};

export const root: SxStyle = {
  border: '2px solid',
  borderColor: 'primary.main',
  borderRadius: 1,
  p: 3,
  display: 'flex',
  flexDirection: 'column',
  gap: 2.5,
  background: GRADIENT,
  boxShadow: '0 0 0 4px rgba(24, 81, 239, 0.10)',
};

export const body: SxStyle = {
  display: 'flex',
  gap: 1.5,
  alignItems: 'stretch',
};
